export function DescCareer() {
    return (
        <div className="container-career">
            <div className="description">
                <p>Interested in doing meaningful work, building for a brand new medium, empowering students all around the
                    world to achieve their dreams? Then you're in the right place! Immerse is a team of interdisciplinary
                    designers, software engineers, and language experts determined to help real people achieve their
                    language learning goals. Take a look at our open positions. We'd love to have you! </p>
            </div>
        </div>
    )
}